import React, { useState, useEffect, useRef } from "react";
import { Checkbox, Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DeleteUnit from "./components/DeleteUnit";
import CopyUnit from "./components/CopyUnit";
import FoamMasticUnit from "./components/FoamMasticUnit";
import ItemConversion from "./components/ItemConversion";
import { read } from "Helpers/LocalStorage";
import { setSelectedUnitCount } from "Stores/actions";
import {
  DESIGN_OPENONEUNIT,
  DESIGN_RESCALE,
  SELECTED_PROJECT,
  SHOW_UNIT_SIDE_DRAWER,
} from "Stores/actionTypes";
import DrawerService from "../../../../Services/http/endpoints/design/DrawerService";
import StatusHandler from "../../../../Helpers/StatusHandler";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import UnitShowMode from "./components/UnitShowComponents/UnitShowMode";
import showNotify from "Helpers/Notify";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

let onScrollLoading = false;

export default function UnitSideDrawer({
  getUnitData,
  setUnitData,
  parentLoading,
  rtl,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    unitList,
    unitListPagination,
    selectedProject,
    isOpenUnitDrawer,
    selectedUnitCount,
    selectedUnitId,
    openUnit,
    showUnitSideDrawer
  } = useSelector((state) => ({
    unitList: state.design.unitList,
    unitListPagination: state.design.unitListPagination,
    selectedProject: state.project.selectedProject,
    isOpenUnitDrawer: state.design.isOpenUnitDrawer,
    selectedUnitCount: state.design.selectedUnitCount,
    selectedUnitId: state.design.selectedUnitId,
    openUnit: state.design.openUnit,
    showUnitSideDrawer: state.design.showUnitSideDrawer,
  }));

  const [isSelectAll, setIsSelectAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [canGet, setCanGet] = useState({ able: false, loaded: 0, total: 0 });
  const [searchValue, setSearchValue] = useState("");
  const [sizePerPage, setSizePerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [changed, setChanged] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(true);
  const [search, setSearch] = useState(false);
  const [showMode, setShowMode] = useState(2);
  const poperRef = useRef(null);
  const [unitSelected, setUnitSelected] = useState(false);
  const [susd, setSusd] = useState(false);
  const [lock, setLock] = useState(false);
  const [size, setSize] = useState(window.innerWidth);

  window.addEventListener("resize", () => {
    setSize(window.innerWidth);
  });

  useEffect(() => {
    if(size <= 992) {
      setSusd(showUnitSideDrawer)
    } else {
      setSusd(false)
    }
  }, [showUnitSideDrawer])

  useEffect(() => {
    if(size <= 992 && !lock) {
      if(selectedUnitId !== 'undefined') {
        dispatch({ type: SHOW_UNIT_SIDE_DRAWER, status: false });
      } else {
        dispatch({ type: SHOW_UNIT_SIDE_DRAWER, status: true });
      }
    }
  }, [selectedUnitId])

  useEffect(() => {
    if (selectedProject && selectedProject !== "undefined") {
      getData(1);
      (async () => {
        await onSelectAll(false);
      })();
    } else {
      dispatch({
        type: SELECTED_PROJECT,
        selectedProject: "undefined",
      });
    }
  }, []);

  useEffect(() => {
    if (
      window.innerWidth < 992 &&
      selectedUnitId &&
      selectedUnitId !== undefined &&
      selectedUnitId !== "undefined"
    )
      setUnitSelected(true);
    else setUnitSelected(false);
  }, [selectedUnitId]);

  const unitReload = (e) => {
    e.preventDefault();
    if (selectedProject && selectedProject !== "undefined") {
      setChanged(false);
      setData([]);
      setCurrentPage(0);
      setTotal(0);
      setCanGet({
        able: false,
        loaded: 0,
        total: 0,
      });
      getData(1);
    } else {
      dispatch({
        type: SELECTED_PROJECT,
        selectedProject: "undefined",
      });
    }
  };

  const setValue = async (name, value) => {
    setSearchValue(value);
  };

  const onSearch = async (e) => {
    e.preventDefault();
    getData(1, true, searchValue);
    setSearch(false);
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearchValue("");
    getData(1, true, "CANCELSEARCH");
    setSearch(false);
  };

  useEffect(() => {
    if (unitList && unitList.length !== 0) {
      setChanged(false);
      setData(unitList);
      setTotal(unitListPagination.Total);
      // setSizePerPage(unitListPagination.Limit);
      setCurrentPage(unitListPagination.Page);
      if (unitList.length < unitListPagination.Total) {
        setCanGet({
          able: true,
          loaded: unitList.length,
          total: unitListPagination.Total,
        });
      } else if (unitList.length > unitListPagination.Total) {
        getData(1);
      } else {
        setCanGet({
          able: false,
          loaded: unitList.length,
          total: unitListPagination.Total,
        });
      }
    } else {
      setChanged(false);
      setData([]);
      setCurrentPage(0);
      setTotal(0);
      setCanGet({
        able: false,
        loaded: 0,
        total: 0,
      });
    }
  }, [unitList, unitListPagination, changed]);

  const getData = async (page, reset = false, search = "") => {
    const _page = page ? page : currentPage + 1;
    const _search =
      search === "CANCELSEARCH"
        ? null
        : search === ""
        ? null
        : { Name: search };
    getUnitData(_page, 20, true, reset, _search);
  };

  const onSelectAll = async (isChecked) => {
    setTimeout(async () => {
      try {
        setLoading(true);
        const data = {
          keyGroup: read("groupKey"),
          keyUser: read("userKey"),
          idProject: selectedProject.Id,
          idUnit: 0,
          checked: isChecked,
        };
        const response = await DrawerService.selectUnitInDrawer(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          dispatch(setSelectedUnitCount(response.data.Value));
          if (unitList.length !== 0) {
            const updateList = unitList.map((item) => {
              return {
                ...item,
                IsSelect: isChecked,
              };
            });
            setUnitData(updateList, unitListPagination);
          }
          setChanged(true);
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
      }
    }, 500);
  };

  useEffect(() => {
    if (selectedUnitCount === unitListPagination.Total) {
      setIsSelectAll(true);
    } else {
      setIsSelectAll(false);
    }
  }, [selectedUnitCount, unitListPagination.Total]);

  const onSelectedChanged = async (item) => {
    const idUnit = item.Id;
    const checked = !item.IsSelect;
    try {
      setLoading(true);
      const data = {
        keyGroup: read("groupKey"),
        keyUser: read("userKey"),
        idProject: selectedProject.Id,
        idUnit,
        checked,
      };
      const response = await DrawerService.selectUnitInDrawer(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch(setSelectedUnitCount(response.data.Value));
        const updateList = [...unitList];
        const index = updateList.findIndex((item) => item.Id === idUnit);
        updateList[index].IsSelect = checked;
        setUnitData(updateList, unitListPagination);
        setChanged(true);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const togglePart = (status) => {
    if (
      window.location.pathname.split("/design/unit/").length > 1 &&
      window.location.pathname.split("/design/unit/")[1] !== ""
    ) {
      setShow(status);
      dispatch({ type: DESIGN_RESCALE, tun: true });
    } else {
      showNotify({
        text: t("toolsSideDrawerWarning"),
        customClass: "warning",
      });
    }
  };

  const openNewUnit = (unitID) => {
    dispatch({ type: DESIGN_OPENONEUNIT, id: unitID });
  };

  useEffect(() => {
    if (openUnit !== 0) setLoading(true);
    else setLoading(false);
  }, [openUnit]);

  const openUnitList = () => {
    setUnitSelected(false);
  };

  const handleScroll = () => {
    const mac = document.getElementById("unit-side-main");
    if (
      (mac.scrollTop >= mac.scrollHeight - mac.offsetHeight - 200) &&
      canGet.able &&
      !onScrollLoading
    ) {
      onScrollLoading = true;
      getData();
      setTimeout(() => {
        onScrollLoading = false;
      }, 500);
    }
  };

  useEffect(() => {
    if (!loading && currentPage !== 0 && sizePerPage !== 0) {
      const mac = document.getElementById("unit-side-main");
      mac && mac.addEventListener("scroll", handleScroll);
      return () => {
        mac && mac.removeEventListener("scroll", handleScroll);
      };
    }
  }, [currentPage, sizePerPage, loading]);

  const onShowUnitSideDrawer = () => {
    if(!lock)
      dispatch({ type: SHOW_UNIT_SIDE_DRAWER, status: !showUnitSideDrawer });
  };

  const onChangeLock = () => {
    setLock(!lock)
  }

  return (
    <>
      {(size > 992 || susd) && (
        <>
          <div
            className={susd ? "unit-side-drawer-back" : ""}
            onClick={onShowUnitSideDrawer}
          />
          {
            (size <= 992 && susd) &&
            <div className="show-unit-side-drawer-lock">
              <MuiIconButton
                title={<Translator id="drawerLock" />}
                icon={lock ? <Icons.Lock /> : <Icons.Unlock />}
                onClick={onChangeLock}
                className={'secondary-button-filled'}
              />
            </div>
          }
          <div className="unit-side-drawer">
            {(loading || parentLoading) && (
              <div className="unit-side-drawer-loading">
                <InnerCircularProgress />
              </div>
            )}
            <div className="unit-options">
              <CopyUnit />
              <FoamMasticUnit />
              <ItemConversion />
              <DeleteUnit
                page={currentPage}
                getUnitData={getUnitData}
                setUnitData={setUnitData}
              />
            </div>
            <div className="unit-list">
              <div className="unit-list-head">
                <MuiIconButton
                  title={<Translator id={"unitSearch"} />}
                  icon={<Icons.Search size={17} />}
                  onClick={() => setSearch(!search)}
                  className="warning-fill"
                />
                <Divider
                  className="head-divider"
                  orientation="vertical"
                  flexItem
                />
                <div className="select-all">
                  <Checkbox
                    onChange={(e) => onSelectAll(e.currentTarget.checked)}
                    checked={isSelectAll}
                    id="units-select-all"
                  />
                  <label htmlFor="units-select-all">
                    <Translator id="all" />
                  </label>
                </div>
                {selectedUnitCount !== 0 && (
                  <>
                    <Divider
                      className="head-divider"
                      orientation="vertical"
                      flexItem
                    />
                    <span className="selected-count">
                      {`${selectedUnitCount} ${t("units")}`}
                    </span>
                  </>
                )}
                {/* <div className="title">
            <MuiIconButton
              title={<Translator id={"unitSearch"} />}
              icon={<Icons.Search size={17} />}
              onClick={() => setSearch(!search)}
              className="warning-fill"
            />
            <Divider className="head-divider" orientation="vertical" flexItem />
            <span className="title_unitList">{t("unitList")}</span>
          </div>
          <div className="selected-unit-items">
            
          </div> */}
              </div>
              <div
                className={`search-box-drawer ${
                  search ? "show-mode" : "hide-mode"
                }`}
              >
                <Input
                  setValue={setValue.bind(this)}
                  name="search"
                  value={searchValue}
                  placeholder={t("unitSearch")}
                  type="search"
                  onSearch={onSearch}
                  onClearSearch={onClearSearch}
                />
              </div>
              <div id="unit-side-main" className="units-exposition">
                {search && (
                  <div
                    className="on-search"
                    onClick={() => setSearch(!search)}
                  />
                )}
                {/* <div className="units-list-body"> */}
                <UnitShowMode
                  data={data}
                  selectedUnitId={selectedUnitId}
                  onSelectedChanged={onSelectedChanged}
                  currentPage={currentPage}
                  loading={loading}
                  setLoading = {(value) => setLoading(value)}
                  openNewUnit={openNewUnit}
                  getUnitData={getUnitData}
                  setUnitData={setUnitData}
                  mode={showMode}
                />
                {/* {!loading && canGet.able && (
              <div className="get-more-button">
                <MuiButton
                  title={t("loadMore")}
                  color="primary"
                  innerIcon={<Icons.CloudArrowDownFill />}
                  onClick={() => {
                    getData();
                  }}
                  className="w-100"
                />
              </div>
            )} */}
                {/* </div> */}
              </div>
              <div className="more-info">
                <span className="text-center mb-4">
                  {`${t("loadUnitCount")}: ${t("loadUnitCountDetail")
                    .replace("@P1", canGet?.loaded)
                    .replace("@P2", canGet?.total)}`}
                  <Icons.ArrowClockwise
                    color="#f5b501"
                    stroke="#f5b501"
                    className="mx-2 handC"
                    onClick={unitReload}
                  />
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
